import React from 'react';
import styles from './password-field.module.scss';

import testIds from '@smart-tv/e2e/shared/variables';

import { FocusContext, setFocus, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import { IconButton } from '@smart-tv/components/icon-button/icon-button';
import HidePasswordIcon from '@smart-tv/components/icons/password-hide';
import ShowPasswordIcon from '@smart-tv/components/icons/password-show';
import TextField, { Props as TextFieldProps } from '@smart-tv/components/input/input';

export const PasswordField = (props: TextFieldProps) => {
  const { onArrowPress: onArrowPressProp, ...rest } = props;
  const [hidePassword, setHidePassword] = React.useState(true);
  const inputFocusKey = 'password-field-input';
  const showHideButtonFocusKey = 'password-field-show-hide-button';

  const { ref, focusKey } = useFocusable({ saveLastFocusedChild: false });

  const handleTogglePasswordVisibility = React.useCallback(() => {
    setHidePassword((previousState) => !previousState);
  }, []);

  const handleInputArrowPress = React.useCallback(
    (direction: string, ...args: unknown[]) => {
      if (direction === 'right') {
        setFocus(showHideButtonFocusKey);
        return false;
      }

      const delegatedResult = onArrowPressProp?.(direction, ...args);

      if (typeof delegatedResult === 'boolean') {
        return delegatedResult;
      }

      return true;
    },
    [onArrowPressProp, showHideButtonFocusKey]
  );

  const handleShowHideButtonArrowPress = React.useCallback(
    (direction: string) => {
      if (direction === 'left') {
        setFocus(inputFocusKey);
        return false;
      }

      return true;
    },
    [inputFocusKey]
  );

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles['password-field']}>
        <TextField
          {...rest}
          type={hidePassword ? 'password' : 'text'}
          focusKey={inputFocusKey}
          onArrowPress={handleInputArrowPress}
        />
        <IconButton
          className={styles['show-hide-button']}
          onClick={handleTogglePasswordVisibility}
          onArrowPress={handleShowHideButtonArrowPress}
          focusKey={showHideButtonFocusKey}
          data-testid={testIds.login.displayPassword}
          background={true}
          size="xl"
          icon={hidePassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
        >
          {' '}
          {hidePassword ? 'Vis kode' : 'Skjul kode'}
        </IconButton>
        {/* </Button> */}
      </div>
    </FocusContext.Provider>
  );
};

export default React.memo(PasswordField);
